
import "../Popover/Popover.st.css.js";
import "../DropdownLayout/DropdownLayout.st.css.js";

import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_187_1_DropdownBase";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_187_1_DropdownBase__root","list":"wds_1_187_1_DropdownBase__list"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-popover-menu-paddings-vertical":"--wds-popover-menu-paddings-vertical","wds-popover-menu-paddings-horizontal":"--wds-popover-menu-paddings-horizontal","wds-border-radius-surface-overlay":"--wds-border-radius-surface-overlay","wds-dropdown-list-paddings":"--wds-dropdown-list-paddings","wds-color-fill-surface-overlay":"--wds-color-fill-surface-overlay"}; 




